import { render, staticRenderFns } from "./edit_auto_mail.vue?vue&type=template&id=9074c94e&scoped=true&"
import script from "./edit_auto_mail.vue?vue&type=script&lang=js&"
export * from "./edit_auto_mail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9074c94e",
  null
  
)

export default component.exports